import UserManagementTeamRoleForm from './UserManagementTeamRoleForm';

export default UserManagementTeamRoleForm;
